import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { PaymentsService } from './services/payments.service';

@NgModule({
  imports: [CommonModule, CoreModule],
  providers: [PaymentsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaymentsModule {}
